import { memo, useMemo } from "react";
import dayjs from "dayjs";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import type { MessageTemplateHeaderFormat } from "../types";
import MessageTemplatePhonePreviewContent from "./MessageTemplatePhonePreviewContent";

export interface MessageTemplatePhonePreviewProps {
  header: string;
  headerFormat?: MessageTemplateHeaderFormat | "NONE";
  headerMediaUrl?: string;
  headerMediaFileName?: string;
  body: string;
  hasButton: boolean;
  buttonText: string;
  buttonType?: string;
  variant?: "default" | "card";
}

const MessageTemplatePhonePreview = memo(
  ({
    header,
    headerFormat,
    headerMediaUrl,
    headerMediaFileName,
    body,
    hasButton,
    buttonText,
    buttonType = "URL",
    variant = "default",
  }: MessageTemplatePhonePreviewProps) => {
    const isCard = variant === "card";

    const footerTime = useMemo(() => dayjs().format("HH:mm"), []);

    return (
      <Box
        sx={{
          width: isCard ? "100%" : 300,
          maxWidth: "100%",
          mx: isCard ? 0 : "auto",
        }}
      >
        {!isCard && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", textAlign: "center", mb: 1, fontWeight: 600 }}
          >
            Prévia
          </Typography>
        )}
        <Box
          sx={{
            overflow: "hidden",
            borderRadius: isCard ? 2 : 0,
            border: isCard ? "1px solid" : "none",
            borderColor: isCard ? "divider" : "transparent",
            boxShadow: isCard ? "0 1px 4px rgba(0,0,0,0.08)" : "none",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{
              px: isCard ? 1 : 1.5,
              py: isCard ? 0.5 : 1,
              backgroundColor: "#075e54",
            }}
          >
            <WhatsAppIcon sx={{ color: "#fff", fontSize: isCard ? 16 : 20 }} />
            <Typography
              variant="caption"
              fontWeight={700}
              sx={{ color: "#fff", fontSize: isCard ? "0.7rem" : undefined }}
            >
              WhatsApp
            </Typography>
          </Stack>

          <MessageTemplatePhonePreviewContent
            isCard={isCard}
            header={header}
            headerFormat={headerFormat}
            headerMediaUrl={headerMediaUrl}
            headerMediaFileName={headerMediaFileName}
            body={body}
            hasButton={hasButton}
            buttonText={buttonText}
            buttonType={buttonType}
            footerTime={footerTime}
          />
        </Box>
      </Box>
    );
  },
);

MessageTemplatePhonePreview.displayName = "MessageTemplatePhonePreview";

export default MessageTemplatePhonePreview;
